import { render, staticRenderFns } from "./AddStorePartner.vue?vue&type=template&id=33b6adf9"
import script from "./AddStorePartner.vue?vue&type=script&lang=js"
export * from "./AddStorePartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports